var Fancyapps = require('@fancyapps/ui');

module.exports = {
    init: function () {
        Fancyapps.Fancybox.bind();
    }
}